import React from 'react';
import { LoadingOutlined } from "@ant-design/icons";
import classnames from "classnames";
import styles from "./LoadingIcon.module.scss";
const LoadingIcon = (props) => {
    return (React.createElement(LoadingOutlined, { style: props.style, className: classnames(styles.spinner, props.additionalStyles) }));
};
export default LoadingIcon;
